// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#phone-enter {
  display: flex;
  flex-direction: column;
  height: 100%;
}

#phone-enter-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: white;
  width: 100%;
}
#phone-enter-header h4 {
  margin: auto;
  color: var(--color-primary);
}

#phone-enter-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  row-gap: 10px;
  height: 100%;
  padding: 25px 0;
}

#phone-enter-form {
  display: flex;
  flex-direction: column;
  width: max(50%, 380px);
  row-gap: 15px;
}

#receive-code-btn {
  width: max(30%, 300px);
}

@media only screen and (max-width: 900px) {
  #phone-enter-body {
    justify-content: space-between;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/register/phone-enter/phone-enter.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AACJ;AAAI;EACI,YAAA;EACA,2BAAA;AAER;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;AACJ;;AAEA;EACI,sBAAA;AACJ;;AAEA;EACI;IACI,8BAAA;EACN;AACF","sourcesContent":["#phone-enter {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n#phone-enter-header {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    background-color: white;\r\n    width: 100%;\r\n    h4 {\r\n        margin: auto;\r\n        color: var(--color-primary);\r\n    }\r\n}\r\n\r\n#phone-enter-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    row-gap: 10px;\r\n    height: 100%;\r\n    padding: 25px 0;\r\n}\r\n\r\n#phone-enter-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: max(50%, 380px);\r\n    row-gap: 15px;\r\n}\r\n\r\n#receive-code-btn {\r\n    width: max(30%, 300px);\r\n}\r\n\r\n@media only screen and (max-width: 900px) {\r\n    #phone-enter-body {\r\n        justify-content: space-between;\r\n    }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
